import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { CartBaseModule } from '@spartacus/cart/base';
import {
  CartDetailsModule,
  CartProceedToCheckoutModule,
  CartSharedModule,
  CartTotalsModule,
  CartValidationWarningsModule,
  ClearCartModule,
} from '@spartacus/cart/base/components';
import { ImportExportModule } from '@spartacus/cart/import-export';
import { ExportOrderEntriesModule } from '@spartacus/cart/import-export/components';
import { SavedCartModule } from '@spartacus/cart/saved-cart';
import {
  AddToSavedCartModule,
  SavedCartComponentsModule,
  SavedCartDetailsModule,
  SavedCartListModule,
} from '@spartacus/cart/saved-cart/components';
import { FeaturesConfigModule, I18nModule, UrlModule, provideDefaultConfig } from '@spartacus/core';
import {
  AtMessageModule,
  DIALOG_TYPE,
  IconModule,
  ItemCounterModule,
  LayoutConfig,
  MediaModule,
  OutletModule,
  PromotionsModule,
  SpinnerModule,
  TotalModule,
  KeyboardFocusModule,
} from '@spartacus/storefront';
import { NgxBootstrapIconsModule, allIcons } from 'ngx-bootstrap-icons';
import { CartSavedCartFeatureModule } from 'src/app/spartacus/features/cart/cart-saved-cart-feature.module';
import { AddToSavedCartComponent } from './add-to-saved-cart/add-to-saved-cart.component';
import { CustomCarItemListRowComponent } from './custom-car-item-list-row/custom-car-item-list-row.component';
import { CustomCarItemListComponent } from './custom-car-item-list/custom-car-item-list.component';
import { CustomCartComponent } from './custom-cart/custom-cart.component';
import { CustomCenterContentComponent } from './custom-center-content/custom-center-content.component';
import { CustomExportComponent } from './custom-export/custom-export.component';
import { CustomOrderSummaryComponent } from './custom-order-summary/custom-order-summary.component';
import { CustomSaveCartComponent } from './custom-save-cart/custom-save-cart.component';
import { CustomSavedCartComponent } from './custom-saved-cart/custom-saved-cart.component';
import { EmptyCartComponent } from './empty-cart/empty-cart.component';
import {
  CartQuickOrderFormModule,
  QuickOrderComponentsModule,
  QuickOrderListModule,
} from '@spartacus/cart/quick-order/components';
import { QuickOrderCoreModule } from '@spartacus/cart/quick-order/core';
import { CustomQuickOrderComponent } from './custom-quick-order/custom-quick-order.component';
import { CustomQuoteEditComponent } from './custom-quote-edit/custom-quote-edit.component';
import { ReactiveFormsModule } from '@angular/forms';
import { CustomQuoteFormComponent } from './custom-quote-form/custom-quote-form.component';
import { SharedModule } from '@shared/shared.module';
import { CustomCartItemCounterComponent } from './custom-cart-item-counter/custom-cart-item-counter.component';
import { CustomSaveCartModalComponent } from './custom-save-cart-modal/custom-save-cart-modal.component';
import { CustomClearCartComponent } from './custom-clear-cart/custom-clear-cart.component';
import { CustomClearCartModalComponent } from './custom-clear-cart-modal/custom-clear-cart-modal.component';
import { FormHeaderComponent } from '@shared/form-header/form-header.component';
import { SelectAddressComponent } from '@shared/select-address/select-address.component';
 
export const CustomCartModalsConfig: LayoutConfig = {
  launch: {
    CUSTOM_SAVE_CART_MODAL: {
      inline: true,
      component: CustomSaveCartModalComponent,
      dialogType: DIALOG_TYPE.DIALOG,
    },
    CUSTOM_CLEAR_CART_MODAL: {
      inline: true,
      component: CustomClearCartModalComponent,
      dialogType: DIALOG_TYPE.DIALOG,
    },
  },
};
 
@NgModule({
  declarations: [
    EmptyCartComponent,
    CustomCartComponent,
    CustomCenterContentComponent,
    CustomSavedCartComponent,
    CustomOrderSummaryComponent,
    CustomCarItemListComponent,
    CustomCarItemListRowComponent,
    AddToSavedCartComponent,
    CustomSaveCartComponent,
    CustomExportComponent,
    CustomQuoteFormComponent,
    CustomQuoteEditComponent,
    CustomCartItemCounterComponent,
  ],
  imports: [
    CommonModule,
    SharedModule,
    CartBaseModule,
    SavedCartModule,
    CartDetailsModule,
    ClearCartModule,
    CartTotalsModule,
    CartProceedToCheckoutModule,
    CartSharedModule,
    PromotionsModule,
    CartSavedCartFeatureModule,
    SavedCartListModule,
    SavedCartComponentsModule,
    SavedCartDetailsModule,
    I18nModule,
    RouterModule,
    UrlModule,
    IconModule,
    CartValidationWarningsModule,
    TotalModule,
    ItemCounterModule,
    AtMessageModule,
    MediaModule,
    ImportExportModule,
    AddToSavedCartModule,
    ExportOrderEntriesModule,
    QuickOrderComponentsModule,
    CartQuickOrderFormModule,
    QuickOrderCoreModule,
    QuickOrderListModule,
    CustomQuickOrderComponent,
    ReactiveFormsModule,
    NgxBootstrapIconsModule.pick(allIcons),
    OutletModule,
    KeyboardFocusModule,
    SpinnerModule,
    CustomClearCartComponent,
    CustomClearCartModalComponent,
    FormHeaderComponent,
    SelectAddressComponent,
    FeaturesConfigModule,
  ],
  exports: [
    EmptyCartComponent,
    CustomCartComponent,
    CustomExportComponent,
    CustomSaveCartComponent,
    CustomCarItemListRowComponent,
  ],
  providers: [provideDefaultConfig(CustomCartModalsConfig)],
})
export class ComponentsModule {}